"use client";

import React from "react";
import { useRouter } from "next/navigation";
import { useClientAuth } from "@/app/providers/client-auth";
import PageLoaderOverlay from "@/components/page-loader-overlay";

export default function Page() {
  const router = useRouter();
  const { status, data } = useClientAuth();

  React.useEffect(() => {
    if (status === "loading") {
      return;
    }

    if (status !== "authenticated") {
      router.replace("/login");
      return;
    }

    const organizationId = data?.activeOrganization.id;
    if (!organizationId) {
      router.replace("/login");
      return;
    }

    router.replace(`/${organizationId}/projects`);
  }, [data?.activeOrganization.id, router, status]);

  return <PageLoaderOverlay message="Loading..." opacity="dark" />;
}
